/* eslint-disable no-unused-vars */
import * as React from 'react';
import PropTypes from 'prop-types';
import { map } from 'ramda';
import { connect } from 'react-redux';

import Table from '@gef-ui/components/organisms/Table';

import { setOpenedTableRows } from 'features/common/collapsibleTable/actions';
import { getOpenTableRow } from 'features/common/collapsibleTable/selectors';

class CollapsibleTable extends React.Component {
	changeChildrenVisibility = (childId) => () => {
		const rows = {
			...map((open) => (this.props.autoCloseOtherRows ? false : open), this.props.openedTableRow),
			[childId]: !this.props.openedTableRow[childId],
		};
		this.props.setOpenTableRows(rows);
	};

	render() {
		const {
			children,
			tableHeader,
			tableBody,
			autoCloseOtherRows,
			tableId,
			openedTableRow,
			setOpenTableRows,
			removeTable,
			...rest
		} = this.props;

		return (
			<Table {...rest}>
				{tableHeader}
				{React.Children.map(tableBody, (child) =>
					React.cloneElement(child, {
						isDetailVisible: this.props.openedTableRow[child.props.id] || false,
						onDetailVisibilityChange: this.changeChildrenVisibility(child.props.id),
						...child.props,
					}),
				)}
				{children}
			</Table>
		);
	}
}

CollapsibleTable.defaultProps = {
	openedTableRow: {},
};

CollapsibleTable.propTypes = {
	autoCloseOtherRows: PropTypes.bool,
	children: PropTypes.any,
	openedTableRow: PropTypes.object,
	removeTable: PropTypes.func,
	setOpenTableRows: PropTypes.func,
	tableBody: PropTypes.any,
	tableHeader: PropTypes.any,
	tableId: PropTypes.string,
};

export default connect(
	(state, { tableId }) => {
		return {
			openedTableRow: getOpenTableRow(state, tableId),
		};
	},
	(dispatch, { tableId }) => {
		return {
			setOpenTableRows: (rows) => dispatch(setOpenedTableRows(tableId, rows)),
		};
	},
)(CollapsibleTable);
